import { useEffect, useState } from 'react';
import _ from 'lodash';

const useSelectedEntities = ({ defaultEntities = [], entityKey } = {}) => {
  const [selectedEntities, setSelectedEntities] = useState(defaultEntities);
  const selectedEntitiesKeys = _.keyBy(selectedEntities, entityKey);

  const addEntity = entity =>
    setSelectedEntities([...selectedEntities, entity]);

  const removeEntity = entity => {
    const entityKeyValue = entity[entityKey];
    const entitiesAfterRemoval = selectedEntities.filter(
      entity => !(entity[entityKey] === entityKeyValue)
    );
    setSelectedEntities(entitiesAfterRemoval);
  };

  const toggleEntity = entity => {
    const entityKeyValue = entity[entityKey];
    return selectedEntitiesKeys[entityKeyValue]
      ? removeEntity(entity)
      : addEntity(entity);
  };

  const isEntitySelected = entityKeyValue =>
    !!selectedEntitiesKeys[entityKeyValue];

  useEffect(() => {
    setSelectedEntities(defaultEntities);
  }, [defaultEntities]);

  return {
    toggleEntity,
    isEntitySelected,
    setValues: setSelectedEntities,
    values: selectedEntities || []
  };
};

export default useSelectedEntities;
